<mf-page title="Editar banco">
  @if (bankDto) {
  <mf-bank
    [bankDto]="bankDto"
    (close)="close()"
    (save)="save($event)" />
  }
</mf-page>
